<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center">Diagnoses <small>{{ client.name }} - {{ visit.date }}</small></h3>
        </v-flex>
        <v-flex xs12 md8 offset-md2 sm10 offset-sm1>
          <v-card>
            <v-card-title color="primary" class="py-1">
              <v-btn small @click="goTo('/clients/' + client.id + '/visits/' + visit.id)" text fab class icon title="Go Back">
                <v-icon class="secondary--text">fa-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn small color="primary" outlined text @click="addDiagnosis = !addDiagnosis">Add</v-btn>
            </v-card-title>
            <v-card-text>
              <diagnoses-table :client="client" :visit="visit" :diagnoses="diagnoses"></diagnoses-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addDiagnosis" @close="addDiagnosis = false">
        <template slot="title">Add Diagnosis</template>
        <create-diagnosis :client="client" :visit="visit" @saved="addDiagnosis = false"></create-diagnosis>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const CreateDiagnosis =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "diagnoses" */ '@/Components/Diagnoses/create')
  const DiagnosesTable =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "diagnoses" */ '@/Components/Diagnoses/index')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'Diagnoses',
    layout,
    props: [
      'client', 'visit', 'diagnoses'
    ],
    metaInfo () {
      return {
        title: 'Diagnoses',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    components: {
      CreateDiagnosis,
      DiagnosesTable,
      ModalDialog,
    },
    data () {
      return {
        filterBy: '',
        headers: [
          {
            text: 'Name', value: 'name',
          },
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'User', value: 'user_name'
          }
        ],
        addDiagnosis: false,
      }
    },
  }
</script>
